export const V2_LAYOUT_EVENT_NAME = "v2LayoutChange";
const v2LayoutEvent = new Event(V2_LAYOUT_EVENT_NAME, {
  bubbles: false,
  cancelable: true,
});

function v2Layout() {
  let initialized = false;
  const route = useRoute();
  const hasV2Feature = computed(() => hasFeatureFlag("v2Wrapper"));
  const [isChatWidgetOpen, toggleChatWidget] = useToggle(false);

  const _v2LayoutEnabled = useLocalStorage<boolean>("v2LayoutEnabled", false);
  const [isCurrentRouteDisplayed, toggleCurrentRoute] = useToggle(false);

  const v2LayoutEnabled = computed(
    () =>
      (_v2LayoutEnabled.value && hasV2Feature.value) ||
      route.name === RouteNames.ONBOARDING
  );
  const _toggleV2Layout = useToggle(_v2LayoutEnabled);

  function toggleV2Layout(value?: boolean) {
    if (!hasV2Feature.value) return;
    _toggleV2Layout(typeof value === "boolean" ? value : !v2LayoutEnabled.value);
    if (v2LayoutEnabled.value) {
      hideScrollbar();
    } else showScrollbar();
    document.dispatchEvent(v2LayoutEvent);
  }

  function switchFromWidgetToV2() {
    toggleV2Layout(true);
    toggleChatWidget(false);
  }

  function switchFromV2ToWidget() {
    toggleV2Layout(false);
    toggleChatWidget(true);
  }

  onMounted(() => {
    console.log({ initialized });
    if (initialized) return;
    if (v2LayoutEnabled.value) hideScrollbar();
    else showScrollbar();
    initialized = true;
  });

  function hideScrollbar() {
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.maxHeight = "100vh";
    document.body.style.overflow = "hidden";
    document.body.classList.add("no-scrollbar");
    document.documentElement.classList.add("no-scrollbar");
  }
  function showScrollbar() {
    document.body.classList.remove("no-scrollbar");
    document.documentElement.classList.remove("no-scrollbar");
    document.documentElement.style.overflow = "auto";
    document.documentElement.style.maxHeight = "none";
    document.body.style.overflow = "auto";
  }

  return {
    v2LayoutEnabled,
    toggleV2Layout,
    hasV2Feature,
    isCurrentRouteDisplayed,
    toggleCurrentRoute,
    isChatWidgetOpen,
    toggleChatWidget,
    switchFromV2ToWidget,
    switchFromWidgetToV2,
  };
}

export const useV2Layout = createSharedComposable(v2Layout);

export function useHiddenV2Input(auto = true) {
  const v2InputStore = useV2InputStore();
  const originalHeight = useSessionStorage<number>(
    "originalBottomSectionHeight",
    defaultV2Height
  );

  function hideInputs() {
    if (v2InputStore.state.hidden) return;
    originalHeight.value = v2InputStore.bottomSectionHeight;
    v2InputStore.currentStateHelpers.hideInputs();
    v2InputStore.toggleBottomSectionHeight(-1);
  }
  function showInputs() {
    v2InputStore.currentStateHelpers.showInputs();
    if (originalHeight.value < 0) originalHeight.value = 0;
    v2InputStore.toggleBottomSectionHeight(originalHeight.value);
  }

  onBeforeMount(() => {
    if (auto) hideInputs();
  });
  onBeforeUnmount(() => {
    if (auto) showInputs();
  });

  return { hideInputs, showInputs };
}

export const useV2Menu = createSharedComposable(() => {
  const [isMenuOpen, toggleMenuOpen] = useToggle();

  return { isMenuOpen, toggleMenuOpen };
});
